// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__FArdi","text-orange":"Card_text-orange__276zv","label":"Card_label__-NFhf"};